import { makeStyles, tokens, webDarkTheme, webLightTheme } from "@fluentui/react-components";
import { PRODUCT_THEME_DEFAULTS } from "../branding/themeContract.js";

export function createMUDSFluentTheme(resolvedTheme) {
  const selected = resolvedTheme || PRODUCT_THEME_DEFAULTS.resolved.dark;
  const color = selected.color;
  const base = selected.appearance === "light" ? webLightTheme : webDarkTheme;

  return {
    ...base,
    colorBrandBackground: color.brandPrimary,
    colorBrandBackgroundHover: color.brandHover,
    colorBrandBackgroundPressed: color.brandPressed,
    colorBrandBackgroundSelected: color.brandPrimary,
    colorBrandBackgroundStatic: color.brandPrimary,
    colorBrandBackground2: color.brandPrimary,
    colorBrandBackground2Hover: color.brandHover,
    colorBrandBackground2Pressed: color.brandPressed,
    colorBrandForeground1: color.brandPrimary,
    colorBrandForeground2: color.brandPrimary,
    colorBrandForegroundLink: color.brandPrimary,
    colorBrandForegroundLinkHover: color.brandHover,
    colorBrandForegroundLinkPressed: color.brandPressed,
    colorBrandStroke1: color.brandPrimary,
    colorBrandStroke2Contrast: base.colorNeutralStroke2,
    colorCompoundBrandBackground: color.brandPrimary,
    colorCompoundBrandBackgroundHover: color.brandHover,
    colorCompoundBrandBackgroundPressed: color.brandPressed,
    colorCompoundBrandForeground1: color.brandPrimary,
    colorCompoundBrandForeground1Hover: color.brandHover,
    colorCompoundBrandForeground1Pressed: color.brandPressed,
    colorCompoundBrandStroke: color.brandPrimary,
    colorCompoundBrandStrokeHover: color.brandHover,
    colorCompoundBrandStrokePressed: color.brandPressed,
    colorNeutralBackground1: color.backgroundSurface1,
    ...(selected.appearance === "dark" ? { colorNeutralBackground2: color.backgroundSurface2 } : {}),
    colorNeutralBackground3: color.backgroundSurface3,
    colorNeutralBackground4: color.backgroundCanvas,
    colorNeutralBackground8: color.backgroundInput,
    colorNeutralBackgroundDisabled: "#F0F0F0",
    colorNeutralForeground1: color.textPrimary,
    colorNeutralForeground2: color.textSecondary,
    colorNeutralForeground3: color.textMuted,
    colorNeutralForegroundDisabled: color.textDisabled,
    colorNeutralForegroundInverted: color.textInverse,
    colorNeutralForegroundOnBrand: color.textOnBrand,
    colorNeutralForeground2BrandHover: color.brandHover,
    colorNeutralForeground2BrandPressed: color.brandPressed,
    colorNeutralForeground2BrandSelected: color.brandPrimary,
    colorNeutralForeground3BrandHover: color.brandHover,
    colorNeutralForeground3BrandPressed: color.brandPressed,
    colorNeutralForeground3BrandSelected: color.brandPrimary,
    colorNeutralStroke1: color.borderDefault,
    colorStrokeFocus2: color.borderFocus,
    colorPaletteGreenForeground1: color.success,
    colorPaletteYellowForeground1: color.warning,
    colorPaletteRedForeground1: color.danger,
    colorPaletteBlueForeground2: color.information,
    primaryColorBackground: color.backgroundSurface1,
    secondaryColorBackground: color.backgroundSurface2,
    primaryColor: color.brandPrimary,
    gray2: color.borderDefault,
    gray3: color.borderStrong,
    gray4: color.textMuted,
    label: { color: color.textMuted }
  };
}

export const MUDSProductDarkTheme = createMUDSFluentTheme(PRODUCT_THEME_DEFAULTS.resolved.dark);

export const useStyles = makeStyles({
  toolbar: { backgroundColor: tokens.colorNeutralBackground2 },
  elements: {
    width: "700px!important",
    padding: "0px",
    "& #muds-elements": {
      padding: "5px"
    }
  },
  hover: {
    "&:hover button": {
      backgroundColor: "var(--primary-color)!important"
    }
  },
  toolbarButtonActive: {
    color: "var(--primary-color-hover)!important",
    "& span": {
      color: "var(--primary-color-hover)!important"
    }
  },
  toolGroup: {
    // display: 'flex',
    // alignItems: 'center',
  },
  toolbarDropdown: {
    "&:hover": {
      color: "inherit!important"
    },
    "& span": {
      minWidth: "28px!important"
    },
    "& svg": {
      color: "var(--colorNeutralForeground2) !important",
      fill: "var(--colorNeutralForeground2) !important"
    }
  },
  assetsPanelContainer: {
    flex: "1",
    overflow: "hidden",
    height: "100%"
  },
  toolbarStepper: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "140px"
  }
});
